import { render, staticRenderFns } from "./phoneDialogComponent.vue?vue&type=template&id=0b217ad7"
import script from "./phoneDialogComponent.vue?vue&type=script&lang=js"
export * from "./phoneDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports